(function($) {
    $('.floated-label').each(function() {
        var $this = $(this);
        var $input = $this.find('input, textarea');

        $input.focus(function(){
            $this.addClass('is-active');
        });

        $input.blur(function(){
            if($input.val() === '' || $input.val() === 'blank'){
                $this.removeClass('is-active');
            }
        });
    });
})(jQuery);
